import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Logger } from '@core/services/logger.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'cass-order-select-issues',
	templateUrl: './select-issues.component.html',
	styleUrls: ['./select-issues.component.css']
})
export class SelectIssuesComponent implements OnInit, OnDestroy {

	private readonly COMPONENT_NAME = "SelectIssuesComponent";

	@Input()
	issueDates: Date[] = [];

	@Input()
	set selectedDates(issues: readonly Date[] | undefined) {
		if (issues) {
			this.daysSelected = issues;
		}
	}

	@Output()
	issuesSelected = new EventEmitter<readonly Date[]>();

	daysSelected: readonly Date[] = [];

	private subscription$?: Subscription;

	constructor(
		private logger: Logger) { }

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		this.subscription$?.unsubscribe();
	}

	handleIssuesSelected(issues: readonly Date[]) {
		this.logger.debug(this.COMPONENT_NAME, `Selecting ${issues?.length} issues`);
		this.issuesSelected.emit(issues);
	}
}
